import React from 'react';

import { formatDate } from '@betterment/core';
import { useGraphQLQuery } from '@betterment/graphql';
import { useAutoNavigate } from '@betterment/js-runtime';
import { DropdownMenu, IconButton, ListRow, Shimmer, Text } from '@betterment/samba-react';

import urlBuilder from '../../../Shared/url-builder';
import { ExecutedAgreementsDocument } from '../graphql/query.executedAgreement.generated';

const LoadingState: React.FC = () => (
  <ListRow css={{ pt: 'space.200' }}>
    <ListRow.LeadingContent>
      <Shimmer css={{ width: '100%', height: 'size.400', borderRadius: 'radii.full', pt: 'space.50' }} />
    </ListRow.LeadingContent>
    <ListRow.TrailingAsset>
      <Shimmer css={{ width: 'size.400', height: 'size.400', borderRadius: 'radii.full' }} />
    </ListRow.TrailingAsset>
  </ListRow>
);

export const ClientAgreementsCardList = () => {
  const navigate = useAutoNavigate();
  const { data, loading } = useGraphQLQuery(ExecutedAgreementsDocument, { variables: { active: true } });
  const handleView = (id: string) => {
    void navigate(urlBuilder.getDocusignExecutedAgreementDownload(id));
  };

  const agreements = data?.firm.executedAgreements ?? [];

  if (loading) {
    return <LoadingState />;
  }

  return agreements.map(agreement => (
    <ListRow key={agreement.id} css={{ pt: 'space.200' }}>
      <ListRow.LeadingContent>
        <Text>{agreement.name}</Text>
        <Text color="text.weak" variant="text50">
          {agreement.approvedAt && <>Uploaded {formatDate(agreement.approvedAt, 'longOrdinalSlashedNonPadded')} • </>}
          {agreement.isDocusignAgreement ? 'Docusign' : 'Checkbox'}
        </Text>
      </ListRow.LeadingContent>
      <ListRow.TrailingAsset>
        <DropdownMenu>
          <DropdownMenu.Trigger asChild={true}>
            <IconButton label="Show options" name="Ellipses" data-testid="dropdown-client-agreement-card-menu" />
          </DropdownMenu.Trigger>
          <DropdownMenu.Content align="center" side="bottom">
            <DropdownMenu.Item onSelect={() => handleView(agreement.id)}>View</DropdownMenu.Item>
            <DropdownMenu.Item onSelect={() => {}}>Replace</DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu>
      </ListRow.TrailingAsset>
    </ListRow>
  ));
};
